import { Injectable } from '@angular/core';
import { Configuration } from '../models';
import { AppConfig } from './app.config';

@Injectable()
export class ImagesService {

  private Config: Configuration;
  constructor() {
    this.Config = AppConfig.config;
  }

  getImagePath(path: string, forceHash: boolean = false, hash: string = null, noAssets: boolean = false): string {
    if (path && (path[0] === '\\' || path[0] === '/')) {
      path = path.slice(1);
    }
    const randomString = hash ? hash : Math.random();
    const randomHashQuery = forceHash ? '?hash=' + randomString : '';
    return `${noAssets ? '' : this.Config.ImagesPath}/${path ? path + randomHashQuery : 'NoFoodPhoto.png'}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/images.service.ts